import { memo, type ReactNode } from 'react';

export type DesignPreviewHeaderBarProps = {
  /** Resolved hex for the header bar background. */
  bannerColor: string;
  children: ReactNode;
};

/**
 * The colored header band of the mini preview. Lays its children out edge-to-edge (workspace
 * identity on the left, search field on the right).
 */
export const DesignPreviewHeaderBar = memo(({ bannerColor, children }: DesignPreviewHeaderBarProps) => (
  <div
    className="flex min-h-[31px] w-full shrink-0 items-center gap-2 px-4 py-2"
    data-testid="SHARE_DESIGN_TAB_PREVIEW_HEADER"
    style={{ backgroundColor: bannerColor }}
  >
    {children}
  </div>
));

DesignPreviewHeaderBar.displayName = 'DesignPreviewHeaderBar';
